var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.candidate !== null
        ? _c("div", [
            _c("input", {
              attrs: { type: "hidden", name: "candidate" },
              domProps: { value: _vm.candidate.id }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "vue-select",
        {
          attrs: { label: "name", filterable: false, options: _vm.options },
          on: { search: _vm.onSearch },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function(option) {
                return [
                  _c("div", { staticClass: "d-center" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: { src: _vm.photo(option) }
                    }),
                    _vm._v(
                      " \n                " +
                        _vm._s(option.full_name) +
                        " (" +
                        _vm._s(option.mobile_number) +
                        ")\n            "
                    )
                  ])
                ]
              }
            },
            {
              key: "selected-option",
              fn: function(option) {
                return [
                  _c("div", { staticClass: "selected d-center" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: { src: _vm.photo(option) }
                    }),
                    _vm._v(
                      " \n                " +
                        _vm._s(option.full_name) +
                        " (" +
                        _vm._s(option.mobile_number) +
                        ")\n            "
                    )
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _vm.candidate,
            callback: function($$v) {
              _vm.candidate = $$v
            },
            expression: "candidate"
          }
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v("\n            Type to search candidates\n        ")
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d6c81ba", { render: render, staticRenderFns: staticRenderFns })
  }
}